import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/icon-box.png'


const _withScopeId = n => (_pushScopeId("data-v-3cc5851e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

import { IProgram } from '@/types/program';
  import { reactive, inject, nextTick, ref, Ref } from 'vue';
  import _ from 'lodash';
  import { useRouter } from 'vue-router';
  import { authStore, userSurveysStore } from '@/stores';
  import { ColorVariants } from '@/constants';
  import Apply from './apply.vue';
  import { goToLogin, request } from '@/utils';
  import ApplyAction from './action.vue';
  import { useI18n } from 'vue-i18n';

  interface IProps {
    program: IProgram;
    showApplyButton: boolean;
    showParticipateButton: boolean;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null,
    showApplyButton: { type: Boolean },
    showParticipateButton: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    program: IProgram;
    showApplyButton: boolean;
    showParticipateButton: boolean;
  }

  const { t } = useI18n();
  const router = useRouter();
  
  const applyRef = ref();
  const refreshPageData = (inject('refreshPageData') || _.noop) as Function;
  const applyActionTeleportNode = inject<Ref<HTMLDivElement>>('applyActionTeleportNode');
  const showApplyAction = inject<() => void>('showApplyAction');
  const hideApplyAction = inject<() => void>('hideApplyAction');
  let showAfterJoinProgramSurvey = false;

  const dialog = reactive({
    login: false,
    email: false,
    address: false,
    info: false,
  });

  const dialogTipMessage = ref('');

  function closeDialog(dialogName?: string) {
    if (dialogName) {
      dialog[dialogName] = false;
    } else {
      _.forEach(dialog, (val, key) => {
        if (val) {
          dialog[key] = false;
        }
      });
    }
    hideApplyAction && hideApplyAction();

    if (showAfterJoinProgramSurvey) {
      showAfterJoinProgramSurvey = false;
      userSurveysStore.tryPopup('after_join_program', props.program.id);
    }
  }

  function showDialog(dialogName: string) {
    closeDialog();
    dialog[dialogName] = true;
    showApplyAction && showApplyAction();
  }

  function showTipDialog(message: string) {
    dialogTipMessage.value = message;
    showDialog('info');
  };

  function login() {
    closeDialog();
    goToLogin();
  }

  function verify() {
    closeDialog();
    router.push({ name: 'mine.memberProfile.edit', query: { type: 'email' } });
  };

  function navToProfileEdit() {
    closeDialog();
    router.push({ name: 'mine.memberProfile.edit' });
  };

  const check = async () => {
    if (!authStore.isLogin) {
      showDialog('login');
      return false;
    }
    await authStore.tryFetchData();
    const emailVerified = _.get(authStore, 'user.profile.email_verified');
    if (!emailVerified) {
      showDialog('email');
      return false;
    }
    if (!authStore.canParticipateProgram) {
      showDialog('address');
      return false;
    }
    return true;
  };

  const participate = async () => {
    const canApply = await check();
    if (canApply) {
      await refreshPageData();
      await nextTick();
      const { show_participate_btn, participate_btn_msg = '', id } = props.program;
      if (!show_participate_btn) {
        showTipDialog(participate_btn_msg);
        return;
      }
      try {
        await request.post(`programs/${id}/participate`, {}, { loading: { silent: true } });
      } catch (e) {
        const errorMsg = _.get(e, 'message');
        showTipDialog(errorMsg);
        throw e;
      }
      await refreshPageData();
      await nextTick();
      showTipDialog(t('dialog_participate_success_content'));
      showAfterJoinProgramSurvey = true;
    }
  };

  const apply = async () => {
    const canApply = await check();
    if (canApply) {
      await refreshPageData();
      await nextTick();
      if (props.program.show_collection_btn) {
        applyRef.value.start();
      } else {
        showTipDialog(props.program.collection_btn_msg as string);
      }
    }
  };


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, {
      to: _unref(applyActionTeleportNode) ? _unref(applyActionTeleportNode) : 'body'
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(applyActionTeleportNode) ? ApplyAction : 'AppDialog'), _mergeProps(_unref(applyActionTeleportNode) ? {} : { class: 'dialog-on-going-program' }, {
        visible: _unref(dialog).login,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).login) = $event)),
        btns: [
        { text: _unref(t)('dialog_login_button'), style: _unref(ColorVariants).dark, click: login }
      ],
        content: _unref(t)('dialog_login_content')
      }), null, 16, ["visible", "btns", "content"])),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(applyActionTeleportNode) ? ApplyAction : 'AppDialog'), _mergeProps(_unref(applyActionTeleportNode) ? {} : { class: 'dialog-on-going-program' }, {
        visible: _unref(dialog).email,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialog).email) = $event)),
        btns: [
        { text: _unref(t)('dialog_email_button'), style: _unref(ColorVariants).dark, click: verify }
      ],
        content: _unref(t)('dialog_email_content')
      }), null, 16, ["visible", "btns", "content"])),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(applyActionTeleportNode) ? ApplyAction : 'AppDialog'), _mergeProps(_unref(applyActionTeleportNode) ? {} : { class: 'dialog-on-going-program' }, {
        visible: _unref(dialog).address,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialog).address) = $event)),
        btns: [
        { text: _unref(t)('dialog_address_button'), style: _unref(ColorVariants).dark, click: navToProfileEdit }
      ],
        content: _unref(t)('dialog_address_content')
      }), null, 16, ["visible", "btns", "content"])),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(applyActionTeleportNode) ? ApplyAction : 'AppDialog'), _mergeProps(_unref(applyActionTeleportNode) ? {} : { class: 'dialog-on-going-program' }, {
        visible: _unref(dialog).info,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_unref(dialog).info) = $event)),
        btns: [
        { text: _unref(t)('dialog_info_button'), style: _unref(ColorVariants).dark, click: () => closeDialog() }
      ],
        content: dialogTipMessage.value
      }), null, 16, ["visible", "btns", "content"]))
    ], 8, ["to"])),
    _createVNode(Apply, {
      ref_key: "applyRef",
      ref: applyRef,
      program: __props.program
    }, null, 8, ["program"]),
    _createElementVNode("div", _hoisted_1, [
      (__props.showParticipateButton)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "apply-button",
            onClick: participate
          }, _toDisplayString(_unref(t)('participate_button_text')), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (__props.showApplyButton)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "apply-button",
                  onClick: apply
                }, [
                  _hoisted_2,
                  _createTextVNode(" " + _toDisplayString(__props.program.program_detail_info_attributes?.collection_btn_text || _unref(t)('apply_for_collection_online')), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64))
    ])
  ], 64))
}
}

})